<!-- Your name and username (used to sign in on other devices). -->
<script lang="ts">
  import FullName from "./FullName.svelte";
  import { untrack } from "svelte";
  import { api } from "../lib/api.ts";
  import { app } from "../lib/store.svelte.ts";
  import { signInName } from "../lib/format.ts";

  let name = $state(untrack(() => app.userName));
  let username = $state(untrack(() => signInName(app.userName, app.username) ?? ""));
  let busy = $state(false);
  const norm = (v: string) => v.trim().replace(/\s+/g, " ").toLowerCase();
  const changed = $derived(name.trim() !== app.userName || norm(username) !== (app.username ?? ""));

  async function save(e: SubmitEvent) {
    e.preventDefault();
    busy = true;
    try {
      const body: Record<string, string> = {};
      if (name.trim() !== app.userName) body.name = name.trim();
      if (username.trim() && norm(username) !== app.username) body.username = username.trim();
      await api("/api/me", { method: "PATCH", body });
      await app.refreshAccount();
      app.toast("Saved");
    } catch (err) {
      app.toast((err as Error).message, "error");
    } finally {
      busy = false;
    }
  }
</script>

<form class="profile" onsubmit={save}>
  <FullName bind:value={name} label="Name" />
  <label class="field">
    <span>Sign-in name</span>
    <input class="input" bind:value={username} autocomplete="username" autocapitalize="words" spellcheck="false" placeholder="Usually your name" />
  </label>
  <button class="btn" disabled={busy || !changed || !name.trim()}>Save</button>
</form>

<style>
  .profile {
    display: flex;
    gap: 10px;
    align-items: flex-end;
    flex-wrap: wrap;
  }

  .profile .field {
    flex: 1 1 200px;
  }
</style>
